import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexProgress',
  setup(__props) {

const BasicProgressbar = defineAsyncComponent(() => import("@/components/theme/uikits/progress/BasicProgressbar.vue"))
const StripedProgressbar = defineAsyncComponent(() => import("@/components/theme/uikits/progress/StripedProgressbar.vue"))
const MultipleBars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/MultipleBars.vue"))
const CustomProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/CustomProgressbars.vue"))
const SmallProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/SmallProgressbars.vue"))
const HeightProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/HeightProgressbars.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Progress bar",
      title: "Progress bar"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicProgressbar))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(StripedProgressbar))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(MultipleBars))
      ]),
      _createVNode(_unref(CustomProgressbars)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(SmallProgressbars))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(HeightProgressbars))
      ])
    ])
  ], 64))
}
}

})